import I18n from "i18next";
import OverViewWidget from "../Common/OverViewWidget";

const ActiveCustomers = ({ data, onClick }) => {
  return (
    <OverViewWidget
      title={I18n.t("overview.activeCustomers")}
      color="#00CBA9"
      legendText={I18n.t("common.total")}
      alertText={I18n.t("overview.customerLast30Days")}
      downloadURL={data.url}
      data={data.data}
      spinner={data.loading}
      barChart={true}
      type="activeCustomer"
      count={data.count}
      showLegendText={true}
      menuSelect={onClick}
      tileName="activeCustomers"
    />
  );
};

export default ActiveCustomers;
